import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnboardingVesselsComponent } from './onboarding-vessels.component';

const routes: Routes = [
  {
    path: '',
    component: OnboardingVesselsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnboardingVesselsRoutingModule {}
